import sectionMarqueeImageCss from '../css-snippets/section-marquee-image';

const html = `
<style>${sectionMarqueeImageCss}</style>
<div id="card-container-unique-id" data-id="unique-id" data-attribute="card-container" data-background="#fbfcf5"
  style="background-color: rgb(251, 252, 245); --marquee-duration: 99.35999999999999s;">
  <div data-attribute="wrap-content" class="wrap-content">
    <div class="marquee-wrapper">
      <div data-attribute="list-item" class="slider-jk">
        <div data-attribute="track" class="track">
          <div class="wrap-item">
            <div class="wrap-img">
              <img loading="lazy" data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2025/10/29/image-6901945de7bfe02bda004c75.webp?w=400&amp;h=50&amp;q=80"
                alt="">
            </div>
          </div>
        </div>

        <div data-attribute="track" class="track">
          <div class="wrap-item">
            <div class="wrap-img">
              <img loading="lazy" data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2025/10/29/image-6901935f04396a2af5eafda9.webp?w=400&amp;h=50&amp;q=80"
                alt="">
            </div>
          </div>
        </div>

        <div data-attribute="track" class="track">
          <div class="wrap-item">
            <div class="wrap-img">
              <img loading="lazy" data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2025/10/29/image-69019367941340dcaefc986a.webp?w=400&amp;h=50&amp;q=80"
                alt="">
            </div>
          </div>
        </div>

        <div data-attribute="track" class="track">
          <div class="wrap-item">
            <div class="wrap-img">
              <img loading="lazy" data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2025/10/29/image-690193707bb8b58642d36333.webp?w=400&amp;h=50&amp;q=80"
                alt="">
            </div>
          </div>
        </div>

        <div data-attribute="track" class="track">
          <div class="wrap-item">
            <div class="wrap-img">
              <img loading="lazy" data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2025/10/29/image-69019379aed14155209ac649.webp?w=400&amp;h=50&amp;q=80"
                alt="">
            </div>
          </div>
        </div>

        <div data-attribute="track" class="track">
          <div class="wrap-item">
            <div class="wrap-img">
              <img loading="lazy" data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2025/10/29/image-690193829957da739b83f089.webp?w=400&amp;h=50&amp;q=80"
                alt="">
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
`;
export default html;
